module.exports = __webpack_public_path__ + "static/media/tongal-logo.96a982ba.svg";